import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { useUserContext } from '../../../../../../context/UserProvider'
import { useNavigate } from 'react-router-dom'
import purchaseReportTableData from './purchaseReportColumns'
import type { Purchase } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatCurrency } from '../../../utils/formatCurrency'

type PurchaseReportTableProps = {
  data: any
  isLoading?: boolean
}

function PurchaseReportTable({ data, isLoading }: PurchaseReportTableProps) {
  // @ts-ignore  remove this ts-ignore when UserContext is type safe
  const { chosenCompany, handleSetConsolidateInvoice } = useUserContext()
  const columns = purchaseReportTableData({ chosenCompany, handleSetConsolidateInvoice })

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      isLoading={isLoading}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} handleSetConsolidateInvoice={handleSetConsolidateInvoice} />
      }}
    />
  )
}

export default PurchaseReportTable

function MobileCardContent({
  row,
  handleSetConsolidateInvoice,
}: {
  row: Row<Purchase>
  handleSetConsolidateInvoice: (value: string) => void
}) {
  const navigate = useNavigate()

  const header = `${row.original.tyear} - ${row.original.tmonth}`
  const data = [
    {
      label: 'Samlefakturakode',
      value: row.original.consolidatedInvoiceAgreement,
    },
    {
      label: 'Beløp',
      value: formatCurrency(row.original.amountIncVAT),
    },
  ]

  const action = {
    onClick: () => {
      handleSetConsolidateInvoice(row.original.consolidatedInvoiceAgreement)
      navigate(`/reports/purchase/${row.original.tyear}-${row.original.tmonth}`)
    },
  }

  return <TableMobileCardContent header={header} data={data} action={action} />
}
